// extracted by mini-css-extract-plugin
module.exports = {"form":"Home_form__3mkrt","input":"Home_input__3derM","search_icon":"Home_search_icon__1dfOs","games_content":"Home_games_content__ZvEdR"};